export abstract class PageBase {

    constructor(document: Document) {
        document.addEventListener('DOMContentLoaded', (ev: Event) => { this.onLoad(ev) });
    }

    protected onLoad(ev: Event) {}
}